module.exports = __webpack_public_path__ + "img/MAH-background.28b46cc4.jpg";